import { ChangeDetectionStrategy, Component, Inject, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Category, CodeCategory, CodeCategoryUtility } from '@jms/model';
import { CODE_PICKER_SERVICE } from '@jms/ui/ui.code.picker.pro';
import { PickerFetch } from '@jms/ui/ui.core.pickers/src/components';
import { PickerBaseComponent } from '@jms/ui/ui.pickers.base';
import { CodePickerService } from '@jms/ui/ui.standalone.services/code.picker.service';
import * as Enumerable from 'linq';
import { map, Observable, of } from 'rxjs';

@Component({
  selector: 'code-category-picker',
  templateUrl: './code.category.picker.component.html',
  styleUrls: ['./code.category.picker.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: CodeCategoryPickerComponent, multi: true },
    CodePickerService
  ],
  standalone: false
})
export class CodeCategoryPickerComponent extends PickerBaseComponent implements OnInit, OnChanges {

  @Input() public data: Category[];
  @Input() public placeholder = '<Code Category>';
  @Input() public appendTo;

  @Input() public includeAllSubcategory = false;

  public data$: Observable<CodeCategory[]>;

  constructor(
    injector: Injector,
    @Inject(CODE_PICKER_SERVICE) private dataService: CodePickerService,
  ) {
    super(injector);
  }

  public async ngOnInit() { }

  public async ngOnChanges(changes: SimpleChanges) {
    this.data$ = this.getData();
  }

  private getData(): Observable<CodeCategory[]> {

    const categories$ = this.fetch === PickerFetch.Automatic
      ? this.dataService.loadCategoriesV2()
      : of(this.data);

    return categories$
      .pipe(
        map(all => {
          return Enumerable
            .from(all)
            .select(category => {
              const codes = [];

              if (this.includeAllSubcategory) {
                codes.push(CodeCategoryUtility.getCodeCategoryAll(category));
              }

              Enumerable.from(category.subCategories)
                .forEach(subcategory => {

                  const codeCategory = CodeCategoryUtility.getCodeCategory(category, subcategory);
                  codes.push(codeCategory);

                });

              return { items: codes };

            })
            .selectMany(i => i?.items)
            .toArray();
        })
      );
  }


}
